// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* protectedLink.css */
.nav-guard-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
}

.nav-guard-modal {
  background: #fff;
  width: 400px;
  max-width: 90%;
  margin: 100px auto 0;
  padding: 1rem;
  border-radius: 6px;
}

.modal-button-row {
  margin-top: 1rem;
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
}

.ok-button {
  background-color: #d33;
  color: #fff;
  border: none;
  padding: 0.4rem 1rem;
  cursor: pointer;
}

.cancel-button {
  background-color: #888;
  color: #fff;
  border: none;
  padding: 0.4rem 1rem;
  cursor: pointer;
}

.file-error-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fdecea;
  border: 1px solid #f5c6cb;
  color: #611a15;
  border-radius: 6px;
  padding: 10px 14px;
  margin-top: 14px;
  font-size: 13px;
  text-align: left;
}
`, "",{"version":3,"sources":["webpack://./src/components/uploadFileModal.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB","sourcesContent":["/* protectedLink.css */\r\n.nav-guard-overlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.5);\r\n  z-index: 9999;\r\n}\r\n\r\n.nav-guard-modal {\r\n  background: #fff;\r\n  width: 400px;\r\n  max-width: 90%;\r\n  margin: 100px auto 0;\r\n  padding: 1rem;\r\n  border-radius: 6px;\r\n}\r\n\r\n.modal-button-row {\r\n  margin-top: 1rem;\r\n  display: flex;\r\n  justify-content: flex-end;\r\n  gap: 1rem;\r\n}\r\n\r\n.ok-button {\r\n  background-color: #d33;\r\n  color: #fff;\r\n  border: none;\r\n  padding: 0.4rem 1rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.cancel-button {\r\n  background-color: #888;\r\n  color: #fff;\r\n  border: none;\r\n  padding: 0.4rem 1rem;\r\n  cursor: pointer;\r\n}\r\n\r\n.file-error-banner {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background-color: #fdecea;\r\n  border: 1px solid #f5c6cb;\r\n  color: #611a15;\r\n  border-radius: 6px;\r\n  padding: 10px 14px;\r\n  margin-top: 14px;\r\n  font-size: 13px;\r\n  text-align: left;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
